module.exports = __webpack_public_path__ + "img/UTANAS-5.429ea174.jpg";